/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import {
  Grid,
  MenuItem,
  TextField,
  Typography,
  Button,
  Divider,
  CircularProgress,
} from "@material-ui/core";
import { HttpRequest } from "../../../utils/httpRequests";
import NavBar from "../../../components/NavBar/NavBar";
import CustomizedSnackbar from "../../../components/CustomizedSnackbar/CustomizedSnackbar";
import { numberDoubleExp } from "../../../utils/regularExpressions";
import LoginMenu from "../../../components/LoginMenu/LoginMenu";

const useStyles = () => ({
  root: {
    padding: 10,
    margin: "70px 20px",
  },
  topMargin: {
    marginTop: 20,
  },
  button: {
    textTransform: "capitalize",
    marginLeft: 10,
    padding: 10,
    width: 110,
  },
});

class F400InventoryItemForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      recordId: 0,

      categoriesData: [],
      categoriesDataLoading: false,
      categoryId: "",
      categoryIdError: "",

      uomData: [],
      uomDataLoading: false,
      uomId: "",
      uomIdError: "",

      label: "",
      labelError: "",

      price: "",
      priceError: "",

      isOpenSnackbar: false,
      snackbarMessage: "",
      snackbarSeverity: "",

      isLoginMenu: false,
      isReload: true,
    };
  }

  componentDidMount() {
    this.getData(
      "/inventory/C400CommonInventoryItemsCategoriesView",
      "categoriesData",
      "categoriesDataLoading"
    );
    this.getData(
      "/inventory/C400CommonInventoryItemsUomView",
      "uomData",
      "uomDataLoading"
    );
  }

  getData = async (endpoint = "", stateName = "", loadingStateName = "") => {
    let resData = [];
    this.setState({
      [loadingStateName]: true,
    });
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}${endpoint}`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      resData = res.data || [];
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
        });
      }
    }
    this.setState({
      [stateName]: resData,
      [loadingStateName]: false,
    });
  };

  handleSnackbar = (isOpen, message, severity) => {
    this.setState({
      isOpenSnackbar: isOpen,
      snackbarMessage: message,
      snackbarSeverity: severity,
    });
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    const errName = `${name}Error`;
    let errMsg = "";
    let regex = "";
    switch (name) {
      case "price":
        regex = new RegExp(numberDoubleExp);
        if (value) {
          if (!regex.test(value)) {
            return;
          }
        }
        break;
      default:
        break;
    }

    this.setState({
      [name]: value || "",
      [errName]: errMsg,
    });
  };

  isFormValid = () => {
    let { categoryIdError, uomIdError, labelError, priceError } = this.state;
    let isValid = true;

    if (!this.state.categoryId) {
      isValid = false;
      categoryIdError = "Please select category.";
    } else {
      categoryIdError = "";
    }

    if (!this.state.label) {
      isValid = false;
      labelError = "Please enter material name.";
    } else {
      labelError = "";
    }

    if (!this.state.uomId) {
      isValid = false;
      uomIdError = "Please select unit of measure.";
    } else {
      uomIdError = "";
    }

    if (!this.state.price) {
      isValid = false;
      priceError = "Please enter price.";
    } else {
      priceError = "";
    }

    this.setState({
      categoryIdError,
      uomIdError,
      labelError,
      priceError,
    });

    return isValid;
  };

  onViewAllButtonClick = () => {
    window.location = "#/R401InventoryItemsView";
  };

  submitForm = async (e) => {
    e.preventDefault();
    this.setState({
      isLoading: true,
    });

    if (this.isFormValid()) {
      const data = new FormData();
      data.append("recordId", this.state.recordId);
      data.append("categoryId", this.state.categoryId);
      data.append("uomId", this.state.uomId);
      data.append("label", this.state.label);
      data.append("price", this.state.price);
      const res = await HttpRequest(
        "POST",
        `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/inventory/C400CommonInventoryItemsSave`,
        data,
        "authorize"
      );
      if (res.isSuccess) {
        this.clearAllData();
        this.handleSnackbar(true, "Save Successfully", "success");
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }

    this.setState({
      isLoading: false,
    });
  };

  clearAllData = () => {
    this.setState({
      recordId: 0,

      categoriesDataLoading: false,
      categoryId: "",
      categoryIdError: "",

      uomDataLoading: false,
      uomId: "",
      uomIdError: "",

      label: "",
      labelError: "",

      price: "",
      priceError: "",
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <Fragment>
        <LoginMenu
          reload={this.state.isReload}
          open={this.state.isLoginMenu}
          handleClose={() => this.setState({ isLoginMenu: false })}
        />
        <CustomizedSnackbar
          isOpen={this.state.isOpenSnackbar}
          message={this.state.snackbarMessage}
          severity={this.state.snackbarSeverity}
          handleCloseSnackbar={() => this.handleSnackbar(false, "", "")}
          autoHideDuration={3000}
        />
        <NavBar isAuthorize />
        <div className={classes.root}>
          <Grid item xs={12}>
            <Typography
              variant="h5"
              color="primary"
              style={{ fontWeight: 700 }}
            >
              Item Opening
            </Typography>
          </Grid>
          <Divider style={{ marginTop: 10, marginBottom: 30 }} />
          <div className={classes.topMargin}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  id="categoryId"
                  name="categoryId"
                  fullWidth
                  label="Category"
                  variant="outlined"
                  onChange={this.handleChange}
                  value={this.state.categoryId}
                  error={!!this.state.categoryIdError}
                  helperText={this.state.categoryIdError}
                >
                  {this.state.categoriesData.map((item) => {
                    return (
                      <MenuItem key={item.id} value={item.id}>
                        {item.label || ""}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  autoComplete="off"
                  id="label"
                  name="label"
                  label="Material Name"
                  variant="outlined"
                  onChange={this.handleChange}
                  value={this.state.label}
                  error={!!this.state.labelError}
                  helperText={this.state.labelError}
                  fullWidth
                ></TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  id="uomId"
                  name="uomId"
                  variant="outlined"
                  fullWidth
                  label="Unit of Measure"
                  onChange={this.handleChange}
                  value={this.state.uomId}
                  error={!!this.state.uomIdError}
                  helperText={this.state.uomIdError}
                >
                  {this.state.uomData.map((item) => {
                    return (
                      <MenuItem key={item.id} value={item.id}>
                        {item.label || ""}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  autoComplete="off"
                  id="price"
                  name="price"
                  variant="outlined"
                  label="Price"
                  onChange={this.handleChange}
                  value={this.state.price}
                  error={!!this.state.priceError}
                  helperText={this.state.priceError}
                  fullWidth
                ></TextField>
              </Grid>
              <Grid align="end" style={{ marginTop: 10 }} item xs={12} sm={12}>
                <Button
                  onClick={(e) => this.submitForm(e)}
                  className={classes.button}
                  color="primary"
                  variant="contained"
                  disabled={this.state.isLoading}
                >
                  {this.state.isLoading ? (
                    <CircularProgress
                      size={23}
                      style={{ color: "white", fontWeight: 600 }}
                    />
                  ) : (
                    "Save Item"
                  )}
                </Button>
                <Button
                  className={classes.button}
                  color="primary"
                  variant="outlined"
                  disabled={this.state.isLoading}
                  onClick={() => this.onViewAllButtonClick()}
                >
                  View All
                </Button>
              </Grid>
            </Grid>
          </div>
        </div>
      </Fragment>
    );
  }
}

F400InventoryItemForm.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles)(F400InventoryItemForm);
